/**
 * Detects errors caused by a failed dynamic import of a lazily-loaded route
 * chunk (e.g. a stale chunk after a deploy, or a transient network failure
 * fetching the chunk).
 *
 * Kept intentionally narrow so genuine render/runtime errors are not
 * misclassified as chunk-load errors: module *evaluation* errors surface with
 * their own message, not the "dynamically imported module" fetch-stage message.
 *
 * @example
 *   isChunkLoadError(new TypeError('error loading dynamically imported module: /assets/ResidentsPage-v-sJ-uVv.js')) // => true
 *   isChunkLoadError(new TypeError('foo is not a function')) // => false
 */
export const isChunkLoadError = (error: unknown): boolean => {
  if (!(error instanceof Error)) {
    return false;
  }
  return (
    error.message.includes('dynamically imported module') ||
    error.message.includes('Loading chunk') ||
    error.name === 'ChunkLoadError'
  );
};
